import api from './axiosInstance';

// this services are shared with DocumentRegister view, from here
export const getDocumentSendStats = {
  getStats: async () => {
    try {
      const response = await api.get(`/DocumentSend/stats`, {
        headers: {
          'Content-Type': 'application/json',
        },
      });
      return response.data;
    } catch (error) {
      error.customMessage =
        'No se pudo obtener la información solicitada. Intenta nuevamente.';
      throw error;
    }
  },
};

export const getDocumentSendDetails = {
  getById: async (id) => {
    try {
      const response = await api.get(`/DocumentSend/${id}`, {
        headers: { 'Content-Type': 'application/json' },
      });
      return response.data;
    } catch (error) {
      error.customMessage =
        'No se pudo obtener los detalles del documento. Intenta nuevamente.';
      throw error;
    }
  },
};

export const putDocumentSendUpdateStatus = {
  putUpdateStatus: async ({ id, userId, statusId, observation, updatedAt }) => {
    try {
      const payload = {
        id,
        userId,
        statusId,
        observation,
        updatedAt,
      };

      const response = await api.put(`/DocumentSend/update-status`, payload, {
        headers: {
          'Content-Type': 'application/json',
        },
      });

      return response.data;
    } catch (error) {
      error.customMessage =
        'No se pudo actualizar el estado del documento. Intenta nuevamente.';
      throw error;
    }
  },
};

// to here

export const getDocumentSendPaged = {
  getPaged: async (
    page,
    pageSize,
    statusId,
    search = '',
    sortBy = null,
    direction = null
  ) => {
    try {
      const params = new URLSearchParams();
      params.append('page', page);
      params.append('pageSize', pageSize);
      params.append('statusId', statusId);
      params.append('search', search);

      if (sortBy) params.append('sortBy', sortBy);
      if (direction !== null) params.append('desc', direction === 'desc');

      const response = await api.get(
        `/DocumentSend/paged?${params.toString()}`,
        {
          headers: {
            'Content-Type': 'application/json',
          },
        }
      );

      return response.data;
    } catch (error) {
      error.customMessage =
        'No se pudo obtener el listado de documentos pendientes. Intenta nuevamente.';
      throw error;
    }
  },
};

export const getDocumentSendAutoSelection = {
  getAutoSelection: async (caseId) => {
    try {
      const response = await api.get(`/DocumentSend/auto-selection/${caseId}`, {
        headers: { 'Content-Type': 'application/json' },
      });
      return response.data;
    } catch (error) {
      error.customMessage =
        'No se pudo obtener el área y/o el servicio de la causa. Intenta nuevamente.';
      throw error;
    }
  },
};

export const getDocumentConfigByService = {
  getByService: async (serviceId) => {
    try {
      const response = await api.get(
        `/DocumentConfigurationSaas/by-service/${serviceId}`,
        {
          headers: { 'Content-Type': 'application/json' },
        }
      );
      return response.data;
    } catch (error) {
      error.customMessage =
        'No se pudo obtener el listado de plantillas por servicio';
      throw error;
    }
  },
};

export const getDocumentSendView = {
  getViewUrl: async (id) => {
    try {
      const response = await api.get(`/DocumentSend/document-send/${id}/view`, {
        headers: {
          'Content-Type': 'application/json',
        },
        responseType: 'blob',
      });

      const file = new Blob([response.data], { type: 'application/pdf' });
      const url = URL.createObjectURL(file);

      return url;
    } catch (error) {
      error.customMessage =
        'No se pudo cargar el PDF del documento. Intenta nuevamente.';
      throw error;
    }
  },
};

export const generateTemplateHTML = {
  generate: async (payload) => {
    try {
      const response = await api.post(
        '/DocumentSend/generate-template',
        payload,
        {
          headers: { 'Content-Type': 'application/json' },
        }
      );

      return response.data;
    } catch (error) {
      error.customMessage = 'No se pudo generar el contenido dinámico.';
      throw error;
    }
  },
};

export const generateTemplatePreview = {
  getTemplate: async (payload) => {
    try {
      const response = await api.post(
        '/DocumentSend/generate-template',
        payload,
        {
          headers: {
            'Content-Type': 'application/json',
          },
        }
      );

      return response.data;
    } catch (error) {
      error.customMessage =
        'No se pudo generar la vista previa del documento. Intenta nuevamente.';
      throw error;
    }
  },
};

export const createDocumentSend = {
  create: async ({
    file,
    name,
    caseId,
    serviceId,
    businessAreaId,
    documentConfigurationId,
    userId,
    createdAt,
  }) => {
    try {
      const formData = new FormData();
      formData.append('file', file);
      formData.append('Name', name);
      formData.append('CaseId', caseId);
      formData.append('ServiceId', serviceId);
      formData.append('BusinessAreaId', businessAreaId);
      formData.append('DocumentConfigurationId', documentConfigurationId);
      formData.append('UserId', userId);
      formData.append('CreatedAt', createdAt);

      const response = await api.post('/DocumentSend', formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });

      return response.data;
    } catch (error) {
      error.customMessage =
        'No se pudo crear el envío del documento. Intenta nuevamente.';
      throw error;
    }
  },
};

export const getDocumentsPaged = async (
  pageNumber,
  pageSize,
  clientId,
  sortBy = 'date',
  sortDir = 'desc'
) => {
  try {
    const response = await api.get('/Documents/GetPagedDocs', {
      params: {
        clientId,
        pageNumber,
        pageSize,
        sortBy: sortBy,
        sortDir: sortDir,
      },
    });

    return response.data;
  } catch (error) {
    error.customMessage =
      'No se pudo obtener el listado de documentos. Intenta nuevamente.';
    throw error;
  }
};

export const downloadDocument = async (id, sourceType) => {
  try {
    const response = await api.get('/Documents/Download', {
      params: { id, sourceType },
      headers: {
        'Content-Type': 'application/json',
      },
      responseType: 'blob',
    });

    return response.data;
  } catch (error) {
    error.customMessage =
      'No se pudo descargar el documento. Intenta nuevamente.';
    throw error;
  }
};
